import StaticForm from './_form'
import template from './new.pug'

export default Vue.extend({
  template: template(),
  components: {
    StaticForm
  },
  data() {
    return {
      lastPath: null,
      lastPathParams: {},
      errors: {}
    }
  },

  created() {
    this.$setPageTitle(this.$t('staticPhone.new.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.staticPhone.index'), route: {name: 'static-phone-index'}},
      {label: this.$t('breadcrumbs.staticPhone.new'), route: {}}
    ])
  },
  methods: {
    createStaticPhone(data) {
      API.callTrackingStaticNumbers.create(data).then(() => {
        this.$notifications.success(this.$t('staticPhone.new.succesfullyCreated'))

        this.$router.push({
          name: this.lastPath || 'static-phone-index',
          params: this.lastPathParams
        })
      }, errors => {
        this.errors = errors
      })
    }
  }
})
